export const FR_APPLICATION_STATUSES = {
  NEW: 'NEW',
  PRE_CHECKS: 'PRE_CHECKS',
  IN_REVIEW: 'IN_REVIEW',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  RESUBMITTED: 'RESUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const FR_STEPS = {
  application_missing: 'application_missing',
  set_goal: 'set_goal',
  awaiting_lender: 'awaiting_lender',
  awaiting_borrower_guarantor: 'awaiting_borrower_guarantor',
  fundraising_summary: 'fundraising_summary',
  fundraising_result: 'fundraising_result',
};